import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'

import { mediaSize } from 'shared/style/var'
import { actions as slotsActions } from 'features/slots'
import { selectAuthCommunication, selectIsUserAuthenticated } from 'features/auth/selectors'
import { slotProvidersConfiguration } from '../configuration'

const withFetchSlotsLayoutContent = (WrappedComponent: React.FC<any>) => (props: any) => {
  const dispatch = useDispatch()
  const isMobileOrTablet = useMediaQuery({ maxWidth: mediaSize.tablet })

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const logoutCommunications = useSelector(selectAuthCommunication, shallowEqual).logout

  useEffect(() => {
    Object.entries(slotProvidersConfiguration).forEach(configuration => {
      dispatch(
        slotsActions.getGameList({
          id: configuration[0],
          provider: configuration[0],
          platform: isMobileOrTablet ? 'mobile' : 'desktop',
        }),
      )
    })
    if (isAuth && !logoutCommunications.isLoading) {
      dispatch(slotsActions.getFavoriteGameList())
    }
  }, [isAuth, dispatch])

  return <WrappedComponent {...props} />
}

export { withFetchSlotsLayoutContent }
